// FIXME: This will eventually replace "_navigation_bar_startups.html.erb"
// Also see: FoodstarterLayout.jsx and compatMode
// Also see: Difference between layouts/application.html.erb and layouts/spa.html.erb

const Navigation = null;

export default Navigation;
